import Vue from 'vue'

/** 
 * This hack allow us create a store especially for summit sidebar.
 * This way we don't need to have a global state.
 */
export const store = Vue.observable({
    doShowSummitSidebar: false,
})